import { AdditionalMedicineInformation } from '@dreryk/drerykweb-medicine-api';

const getMedicineDetailsAdditionalInformationContentText = (
   key: keyof AdditionalMedicineInformation,
   data: AdditionalMedicineInformation
): string => {
   switch (key) {
      case 'address':
         return `${data.street}, ${data.zipCode} ${data.city}`;
      case 'atcCodes':
         return data[key].join(', ');
      default:
         return data[key];
   }
};

export { getMedicineDetailsAdditionalInformationContentText };
